import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import { HTMLAttributes } from 'react'

export const MobileBodyNotScroll = styled.div<HTMLAttributes<HTMLDivElement>>`
    box-sizing: border-box;
    background-color: ${ThemeColors.white};
    padding-bottom: 171px;
`

export const MobileBodyNotScrollForm = styled.form<HTMLAttributes<HTMLFormElement>>`
    box-sizing: border-box;
    background-color: ${ThemeColors.white};
    padding-bottom: 171px;
`

export const ScrollWrapper = styled.div`
    overflow: auto;
    padding-bottom: 5rem;
    max-height: 100%;
`

export const Container = styled.div`
    & > * {
        margin-top: 1rem;
        max-width: 20rem;
    }
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`
